/**
 * Fan-out for new-trend announcements to the channels the user opted into
 * (email and/or web push) on top of the in-app toast.
 */
import { supabase } from "@/integrations/supabase/client";
import { showTrendPushNotification } from "@/lib/trendPush";
import {
  trendDeepLinkUrl,
  type ToastPlan,
  type TrendNotifySettings,
} from "@/lib/trendNotifications";

export async function deliverTrendAlert(
  plan: ToastPlan,
  title: string,
  settings: TrendNotifySettings,
): Promise<void> {
  if (plan.kind === "none" || plan.ids.length === 0) return;
  const first = plan.ids[0];
  const body =
    plan.kind === "summary"
      ? "Open your dashboard to review everything curated since your last summary."
      : "Tap to open the trend and its blueprint.";

  if (settings.push) {
    await showTrendPushNotification(title, body, first);
  }

  if (settings.email) {
    try {
      await supabase.functions.invoke("send-trend-alert", {
        body: {
          title,
          body,
          mode: plan.kind,
          trendIds: plan.ids.slice(0, 25),
          url: trendDeepLinkUrl(first),
        },
      });
    } catch {
      /* email alerts are best-effort; the in-app toast already fired */
    }
  }
}
